import { useState, type FormEvent } from "react";
import { Button } from "../components/rumonai";
import { LightMotion } from "../components/LightMotion";
import { ErrorState } from "../shell/ui";
import { PasswordField } from "./AuthShell";
import { hub } from "./api";
import "../connections/settings-list.css";

/**
 * 设置 › 账号: the signed-in person changes their own password.
 *
 * It sits beside 当前账号 because that row is where the Hub already shows a
 * person their own account. The Hub asks for the current password, signs every
 * other browser out and keeps this one; a refusal keeps what was typed and says
 * why, and nothing here claims a change the Hub did not answer.
 */
export function AccountPassword({ accountName }: { accountName: string }) {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [password, setPassword] = useState("");
  const [currentHidden, hideCurrent] = useState(true);
  const [newHidden, hideNew] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [done, setDone] = useState(false);
  const ready = Boolean(current) && password.length >= 8;
  const close = () => {
    setOpen(false);
    setCurrent("");
    setPassword("");
    setError(null);
    hideCurrent(true); hideNew(true);
  };
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    if (busy || !ready) return;
    setBusy(true);
    setError(null);
    try {
      await hub.changePassword(current, password);
      close();
      setDone(true);
    } catch (failure) {
      setError(failure);
    } finally {
      setBusy(false);
    }
  };
  return <section className="settings-block workspace-setting-row account-password" aria-labelledby="account-password-title">
    <div>
      <h3 id="account-password-title">密码</h3>
      <p>修改后，其他设备上的登录会退出。</p>
      {done ? <p className="account-password-done" role="status">密码已修改。</p> : null}
    </div>
    {!open ? <Button variant="secondary" name="change-password"
      onClick={() => { setOpen(true); setDone(false); }}>修改密码</Button> : null}
    {open ? <form onSubmit={event => { void submit(event); }} aria-busy={busy}>
      {/* For the browser's password manager: whose password this is. */}
      <input type="text" name="username" autoComplete="username" value={accountName} readOnly hidden />
      <PasswordField label="当前密码" name="current-password" placeholder="当前账号使用的密码"
        autoComplete="current-password" value={current} onChange={setCurrent} setting={false}
        disabled={busy} hidden={currentHidden} onHide={hideCurrent} />
      <PasswordField label="新密码" name="new-password" placeholder="至少 8 位" hint="至少 8 个字符。"
        autoComplete="new-password" value={password} onChange={setPassword} setting
        disabled={busy} hidden={newHidden} onHide={hideNew} />
      {error ? <ErrorState error={error} /> : null}
      <div className="account-password-actions">
        <Button type="submit" disabled={busy || !ready} aria-busy={busy}>
          {busy ? <><LightMotion state="working" compact />正在保存…</> : "保存新密码"}
        </Button>
        <Button variant="ghost" disabled={busy} onClick={close}>取消</Button>
      </div>
    </form> : null}
  </section>;
}
